export const APP_CONFIG = {
  appName: 'Trinity Health',
  frontend: 'https://trinitybenefits.org',
  apiHash: 'https://trinitybenefits.org/api/1.0',
  api: '/api/2.0',
  trustModel: false,
  commitSHA: '1664030',
  authHeaders: {
    xServiceProvider: 'trinityhealth-prod-frontend',
    'tenant-id': '6bcfc8df-701b-4ac5-a3d9-93d7edca5c65',
    'consumer-id': '75dc86d3-e1ee-4759-bebc-40abc737bce4',
  },
  provider: 'trinityhealth-prod-frontend',
  colors: {
    primary: '#02794d',
    secondary: '#02794d',
  },
  multilingual: false,
  demoMode: false,
  contactEnabled: false,
  benefitCategories: true,
  articleThumbnails: true,
  showNotifications: true,
  showSearch: true,
  showHeroImages: true,
  showPosts: true,
  blurredBackground: false,
  imagery: {
    logo: 'https://storage.googleapis.com/gc-storage-public-us/trinity-logo.png',
    logoInverted: 'https://storage.googleapis.com/gc-storage-public-us/trinity-logo.png',
    logoTransparent: 'https://storage.googleapis.com/gc-storage-public-us/trinity-logo.png',
  },
  gtm: 'GTM-TSNCGFR4',
  copyright: '<small>&copy; ' + new Date().getFullYear() +
      ' Gallagher | All Rights Reserved.' + '<br />Powered by Core.' + '</small>',
  navigation: {
    navType: 'top',
    collapsibleSidenav: false,
    headerStyle: 'solid',
    stickyNav: true,
    fullWidthNavigation: false,
    categoryNav: true
  },
  coreLinkify: true,
  enableSSR: false,
  cookiePolicy: 'b947b790',
};
